import { render, staticRenderFns } from "./advertisingManagement.vue?vue&type=template&id=33238e98&"
import script from "./advertisingManagement.vue?vue&type=script&lang=js&"
export * from "./advertisingManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33238e98')) {
      api.createRecord('33238e98', component.options)
    } else {
      api.reload('33238e98', component.options)
    }
    module.hot.accept("./advertisingManagement.vue?vue&type=template&id=33238e98&", function () {
      api.rerender('33238e98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/advertisingManagement.vue"
export default component.exports